import React from "react";
import FeatureCard from "../FeatureCard/FeatureCard";
import Heading from "../Heading/Heading";
import img1 from "../../images/feature/app-dev.svg";
import img2 from "../../images/feature/web-dev.svg";
import img3 from "../../images/feature/web-des.svg";

const features = [
  {
    id: 1,
    title: "Web Design",
    img: img3,
    des: "Web design is an essential component of creating an engaging and effective website or web application. The design of a website can have a significant impact on user experience, engagement, and conversion rates. A well-designed website can help to establish brand identity, communicate a message effectively, and create a positive impression on visitors.",
  },
  {
    id: 2,
    title: "Web Development",
    img: img2,
    des: "Web development is an essential part of building and maintaining a strong online presence for businesses, organizations, and individuals. A well-designed and functional website can help to attract and retain customers, provide a platform for online sales and marketing, and establish credibility and professionalism in the eyes of potential clients and customers.",
  },
  {
    id: 3,
    title: "App Development",
    img: img1,
    des: "App development has become an essential part of the digital landscape, as more people use mobile devices to access information, services, and products. Mobile apps provide a convenient, accessible, and user-friendly way for businesses, organizations, and individuals to connect with their audiences.",
  },
];

const Feature = () => {
  return (
    <section id="feature" className="mt-5">
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <Heading title1="Feature" title2="What I'm Do" />
          </div>
          {features.map((feature) => (
            <FeatureCard key={feature.id} feature={feature} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Feature;
